import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function MySuccessModal() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="success" onClick={handleShow}>
        My Success Modal
      </Button>

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        contentClassName="bg-purple-gradient-darker-reverse"
        style={{ minHeight: 300 }}
      >
        <Modal.Header closeButton className="bg-colored-reverse text-white">
          <Modal.Title className="px-4">Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="px-4">
            <div className="bg-green-success  p-3 rounded-3 mb-4">
              SUCCESS MESSAGE EXAMPLE
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
              <Button
                className="btn btn-dark btn-sm text-white rounded-pill px-5"
                onClick={handleClose}
              >
                CANCEL
              </Button>
              <Button
                className="btn btn-sm btn-colored-reverse rounded-pill px-5"
                onClick={handleClose}
              >
                SAVE
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MySuccessModal;
